import { connect } from 'react-redux';
import { Dataset, loadDataset, selectDatasetByProductId, State as ProductDatasetState } from '~/ProductDataset';

import DatasetRawData from './Dataset';

function mapStateToProps(
	{ productDataset }: { productDataset: ProductDatasetState },
	{
		productId,
	}: {
		productId: string;
	}
): {
	isFetching: boolean;
	dataset: Dataset | null;
} {
	const datasetState = selectDatasetByProductId(productDataset, productId);
	return {
		isFetching: datasetState?.isFetching === true,
		dataset: datasetState?.dataset || null,
	};
}

const actions = {
	onLoad: loadDataset,
};

export default connect(mapStateToProps, actions)(DatasetRawData);
